import type { IconData } from '@stacksjs/iconify-core'

export const travelMap: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.333 2.5L0 0v13.5L4.333 16zm1.5 0L10.166 0v13.5L5.833 16zM16 2.5L11.666 0v13.5L16 16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default travelMap
